var Handlebars = require("/Users/mudio/Desktop/baidu/bce-multimedia/cyberplayer/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.escapeExpression, alias2=container.lambda;

  return "                <li class='jw-option jw-text jw-active-option jw-item-"
    + alias1(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"index","hash":{},"data":data}) : helper)))
    + " jw-reset'>\n                    <span class=\"jw-label jw-reset\"><span class=\"jw-icon jw-icon-play jw-reset\"></span></span>\n                    <span class=\"jw-name jw-reset\" title=\""
    + alias1(alias2((depth0 != null ? depth0.title : depth0), depth0))
    + "\">"
    + alias1(alias2((depth0 != null ? depth0.title : depth0), depth0))
    + "</span>\n                </li>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.escapeExpression, alias2=container.lambda;

  return "                <li class='jw-option jw-text jw-item-"
    + alias1(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"index","hash":{},"data":data}) : helper)))
    + " jw-reset'>\n                    <span class=\"jw-label jw-reset\">"
    + alias1(alias2((depth0 != null ? depth0.label : depth0), depth0))
    + "</span>\n                    <span class=\"jw-name jw-reset\" title=\""
    + alias1(alias2((depth0 != null ? depth0.title : depth0), depth0))
    + "\">"
    + alias1(alias2((depth0 != null ? depth0.title : depth0), depth0))
    + "</span>\n                </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"jw-menu jw-playlist-container jw-background-color jw-reset\">\n\n    <div class=\"jw-tooltip-title jw-reset\">\n        <span class=\"jw-icon jw-icon-inline jw-icon-playlist jw-reset\"></span>\n        <span class=\"jw-text jw-reset\">播放列表</span>\n    </div>\n\n    <ul class=\"jw-playlist jw-reset\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./~/handlebars-loader!./src/templates/playlist.html
 ** module id = 196
 ** module chunks = 0
 **/